'use client';
import { useContext } from 'react';
import { buildItemTags } from '@/entities/cart';
import { prefabsStore } from '@/shared/ui/modal/prefabs-store';
import { Tags } from '@/shared/ui/tags';
import { ProductDetailContext } from './provider';

const TEST_ID = 'product-detail-tags';

type Props = { variant?: 'inImage' | 'default' };

/**
 * Renders the current item's tags in the product detail. Placement (below the
 * title vs over the image) and appearance are JSON-config driven, mirroring the
 * product card. Renders nothing when the item has no tags.
 */
export const ProductDetailTags = ({ variant = 'default' }: Props) => {
    const { currentItem } = useContext(ProductDetailContext);
    const tags = buildItemTags(currentItem?.tags);

    if (!tags) {
        return null;
    }

    const settings = prefabsStore.getProductTags();
    const isOverImage = (settings?.placement ?? 'belowImage') === 'overImage';
    const appearance = settings?.appearance ?? 'outline';

    // Render only the slot matching the configured placement to avoid duplicates.
    if (variant === 'inImage' && !isOverImage) {
        return null;
    }
    if (variant !== 'inImage' && isOverImage) {
        return null;
    }

    return (
        <Tags
            tags={tags}
            appearance={appearance}
            data-testid={TEST_ID}
            className={variant === 'inImage' ? 'product-detail__image-tags' : 'product-detail__tags'}
        />
    );
};
